var _path, _mask, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeliveryKeys = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 46,
  viewBox: "0 0 48 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 45.1948C37.2548 45.1948 48 35.0776 48 22.5974C48 10.1172 37.2548 0 24 0C10.7452 0 0 10.1172 0 22.5974C0 35.0776 10.7452 45.1948 24 45.1948Z",
  fill: "#BCD9C9"
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 48,
  height: 46
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 45.1948C37.2548 45.1948 48 35.0776 48 22.5974C48 10.1172 37.2548 0 24 0C10.7452 0 0 10.1172 0 22.5974C0 35.0776 10.7452 45.1948 24 45.1948Z",
  fill: "white"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 7.71423,
  y: 16.9481,
  width: 31.7143,
  height: 36.9776,
  rx: 3,
  fill: "#F1F6F4"
}), /*#__PURE__*/React.createElement("rect", {
  x: 6.75,
  y: 16.084,
  width: 34.5,
  height: 29.975,
  rx: 3.25,
  stroke: "#727D79",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 25.0184,
  width: 12.8571,
  height: 1.6141,
  rx: 0.80705,
  fill: "#999E9C"
}), /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 29.0537,
  width: 12.8571,
  height: 1.6141,
  rx: 0.80705,
  fill: "#999E9C"
}), /*#__PURE__*/React.createElement("rect", {
  x: 28.2858,
  y: 33.0891,
  width: 8.57143,
  height: 1.6141,
  rx: 0.807049,
  fill: "#999E9C"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.7136 29.607C18.1984 30.345 20.0888 30.0098 21.1091 29.0199C22.4065 27.7598 22.2709 25.5793 20.8066 24.1581C19.3424 22.737 17.095 22.6056 15.7978 23.8646C14.7772 24.8555 14.4318 26.6895 15.1927 28.131L10 33.1701L10.1585 33.3241L11.5209 34.6463L12.9159 36L14.0566 34.8929L12.6623 33.5391L13.4228 32.8012L14.8171 34.1549L15.9577 33.0478L14.5635 31.6939L16.7136 29.607ZM17.0078 25.04C17.6391 24.4273 18.7978 24.5577 19.5961 25.3325C20.3949 26.1082 20.5299 27.2327 19.8986 27.8453C19.2673 28.4571 17.8399 28.5875 17.0418 27.8128C16.2431 27.038 16.3765 25.6516 17.0078 25.04Z",
  fill: "#FF8B22"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeliveryKeys);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/deliveryKeys.9fcbf01694cbb093df5c8188c5312392.svg";